/* Wintenook landing — countdown to local midnight (same logic as the design). */
(function () {
  if (window.__wnLanding) return;
  window.__wnLanding = true;

  var KEY = 'wn_sale_end';

  function saleEnd() {
    var end = 0;
    try { end = +localStorage.getItem(KEY) || 0; } catch (e) {}
    if (!end || end < Date.now()) {
      var d = new Date();
      d.setHours(23, 59, 59, 0);
      end = d.getTime();
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }

  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

  function tick() {
    var left = Math.max(0, Math.floor((saleEnd() - Date.now()) / 1000));
    var h = pad(Math.floor(left / 3600));
    var m = pad(Math.floor((left % 3600) / 60));
    var s = pad(left % 60);
    document.querySelectorAll('[data-wn-h]').forEach(function (el) { el.textContent = h; });
    document.querySelectorAll('[data-wn-m]').forEach(function (el) { el.textContent = m; });
    document.querySelectorAll('[data-wn-s]').forEach(function (el) { el.textContent = s; });
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* Re-tick when sections are re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', tick);
})();
